import initializeComponent from '../react-initialize';
import PopupContainer from './popup_container';
import * as actions from './actions';

export { actions as PopupActions };

initializeComponent('PopupModal', PopupContainer);
